'use client';

import type { FC, ReactNode } from 'react';

interface LayoutProps {
  children: ReactNode;
  showCategoryNav?: boolean;
  showFooter?: boolean;
}

const withLayout = <P extends object>(
  Component: FC<P>,
  Layout: FC<LayoutProps>,
  layoutProps?: Omit<LayoutProps, 'children'>,
): FC<P> => {
  const WrappedComponent: FC<P> = (props) => (
    <Layout {...layoutProps}>
      <Component {...props} />
    </Layout>
  );

  return WrappedComponent;
};

export default withLayout;
